require('./bootstrap');
require('slick-carousel');
require('bootstrap-select');
require('bootstrap-select/dist/js/i18n/defaults-sk_SK.min')
require('magnific-popup')
import 'vanilla-cookieconsent'
import * as CookieConsent from "vanilla-cookieconsent";
import "vanilla-cookieconsent/dist/cookieconsent.css";


const slickUpper = $('.slick-upper')
const partnersSlick = $('.partners .slick-items')

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    },
    type: 'POST',
    cache: false
});

$('select').selectpicker();

$(function () {
    if($('#appDetail').length) {
        let galleryHeight = $('.gallery').height()
        let descriptionHeight = $('.description').height()
        if(descriptionHeight < galleryHeight) {
            $('.hr-spacer').css('margin-top', (galleryHeight+80)+'px')
        }
    }

    $("#magicBtn").on("click", function () {
        $("#mesto").toggle(this.checked);
    });
    $('.gallery-item').magnificPopup({
        type: 'image',
        gallery: {
            enabled:true,
            tPrev: 'Predošlí (Ľavá šípka)',
            tNext: 'Ďalší (Práva šípka)',
            tCounter: '%curr% z %total%'
        },
        image: {
            tError: '<a href="%url%">Obrázok</a> nebolo možné načítať.'
        },
    });

    $('.magnific-gallery').each(function() {
        $(this).magnificPopup({
            delegate: 'a',
            type: 'image',
            preload: [1,2],
            gallery: {
                enabled:true,
                tPrev: 'Predošlí (Ľavá šípka)',
                tNext: 'Ďalší (Práva šípka)',
                tCounter: '%curr% z %total%'
            },
            image: {
                tError: '<a href="%url%">Obrázok</a> nebolo možné načítať.'
            },
        });
    });
    let hash = window.location.hash
    hash = hash.replace('#', ".");
    $(hash).trigger('click');
});

$('.copy-realization').on('click touch', function () {
    let realizationHash = $(this).data('realization-hash')
    let URL_TEXT = window.location.origin + '/realizacie' + realizationHash
    copyRealization($(this), URL_TEXT)
})
const copyRealization = function(elem, copyText) {
    let textArea = document.createElement("textarea");
    textArea.value = copyText;
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
        let successful = document.execCommand("copy");
        if (successful && elem) {
            elem.html("Skopírované");
            setTimeout(function () {
                elem.html("Zdieľať");
            }, 1000);
        }
    } catch (err) {
        console.error("Fallback: Oops, unable to copy", err);
    }
    document.body.removeChild(textArea);
}

let filterProductsSection = $('#filter-products-section');
if(filterProductsSection.length && $('#appProducts').length) {
    require('./jquery.hash')
    const categoryId = filterProductsSection.data('category-id')
    
    let priceTimer;
    $('body').on('input', '.price-filter-input', function () {
        let el = $(this);
        let val = el.val();
        let slug = el.data('hash');

        clearTimeout(priceTimer);
        priceTimer = setTimeout(function () {
            if (val !== "") {
                $.hash.set(slug, val);
            } else {
                $.hash.remove(slug);
            }
            filterProducts(true, slug);
        }, 800);
    });

    $('body').on('click', '.sort-btn', function () {
        let btn = $(this);
        let newValue = btn.data('value');
        let input = $('#sort-value');

        if (btn.hasClass('active')) {
            btn.removeClass('active');
            input.val(''); 
        } else {
            $('.sort-btn').removeClass('active');
            btn.addClass('active');
            input.val(newValue);
        }

        filterProducts(true, 'sort');
    });

    $('body').on('change', '.filters select', function () {
        filterSelect($(this))
    });

    const getHash = function () {
        let hash = $.hash.getParamsObject()
        if ($.isEmptyObject(hash)) {
            return false
        } else {
            $.each(hash, function (key, value) {
                let trimedKey = key
                if(trimedKey.includes("-")) {
                    trimedKey = trimedKey.substring(0, trimedKey.indexOf('-'));
                }
                if ($.type(value) == 'string') {
                    hash[trimedKey] = decodeURI(value).split(',')
                }
            })
            return hash
        }
    }

    const filterProducts = function (remove, slug = null) {
        if(remove) {
            $.hash.remove('page')
        }
        let hash = getHash()
        let sort = $('[name="sort"]').val();
        
        let ajaxUrl = new URL(window.location.origin + '/filter');
        if(window.location.href.includes("?page=")) {
            let urlParams = new URLSearchParams(window.location.search);
            let pageNum = urlParams.get("page");
            if (pageNum && !remove) {
                ajaxUrl.searchParams.set('page', pageNum);
            }
        }

        $.ajax({
            url: ajaxUrl.pathname + ajaxUrl.search,
            type: 'POST',
            cache: false,
            data: {hash: hash, categoryId: categoryId, slug: slug, sort: sort},
            dataType: 'html',
            success: function (data) {
                if (data != 'false') {
                    $("#filter-products-section").empty().html(data);
                    $('select').selectpicker('refresh');
                    reInitFilter()
                    
                    var links = $('.hash-pagination').find('a');
                    var currentSort = $('[name="sort"]').val();
                    
                    links.each(function(){
                        try {
                            var href = $(this).attr('href');
                            var url = new URL(href, window.location.origin);
                            if (currentSort) {
                                url.searchParams.set('sort', currentSort);
                            }
                            $(this).attr('href', url.pathname + url.search + window.location.hash);
                        } catch(e) {
                            console.error("URL repair failed", e);
                        }
                    });
                } else {
                    console.log('Ajax Error in script')
                }
            },
            error: function (jqXHR, textStatus) {
                console.log('Ajax', 'Error', textStatus)
            }
        })
    }

    const checkEmptyHash = function () {
        if (getHash() === false) {
            history.pushState({}, document.title, location.href.replace('#', ''))
        }
    }

    const filterSelect = function (e) {
            e = $(e)
            let vals = e.val()
            let slug = e.data('hash')

            if(!slug || slug === 'sort') {
                filterProducts(true, null);
                return;
            }

            if(slug.includes("-")) {
                slug = slug.substring(0, slug.indexOf('-'));
            }
            if(!vals.length && slug !== 'vyrobca') {
                let top = $(window).scrollTop()
                $.hash.remove(slug)
                checkEmptyHash()
                $(window).scrollTop(top)
            } else {
                if(!vals.length && slug === 'vyrobca') {
                    $.hash.remove('vyrobca')
                } else {
                    if(slug === 'vyrobca') {
                        let hash = getHash()
                        $.each(hash, function (key,j) {
                            $.hash.remove(key)
                        })
                        $.hash.remove()
                    }
                    $.hash.set(slug, vals)
                }
            }
        filterProducts(true, slug)
    }

    const reInitFilter = function () {
        let hash = getHash()
        let urlParams = new URLSearchParams(window.location.search);
        let urlSort = urlParams.get('sort');

        if(urlSort) {
            $('#sort-value').val(urlSort);
            $('.sort-btn').removeClass('active');
            $('.sort-btn[data-value="' + urlSort + '"]').addClass('active');
        }

        // Zabezpečenie, aby hodnoty v poliach ceny nemizli po AJAX načítaní
        if (hash) {
            if (hash['price_from']) {
                $('[data-hash="price_from"]').val(hash['price_from'][0]);
            }
            if (hash['price_to']) {
                $('[data-hash="price_to"]').val(hash['price_to'][0]);
            }
        }

        $('select').each(function () {
            let e = $(this)
            let hashValues = hash ? hash[e.data('hash')] : null;
            if (hashValues) {
                e.val(hashValues)
            }
            e.selectpicker('refresh')
        })
    }

    $(function () {
        filterProducts(false)
        if (getHash() !== false || window.location.search.includes('sort=')) {
            reInitFilter()
        }
        $('body').on('click touch', '#more-products', function () {
            let moreProducts = $(this);
            if(moreProducts.hasClass('not-last')) {
                let nextPage = moreProducts.data('next-page')
                let hash = getHash()
                let sort = $('[name="sort"]').val();
                $.ajax({
                    url: '/next-products?page='+nextPage+window.location.hash,
                    type: 'POST',
                    cache: false,
                    data: {hash: hash, categoryId: categoryId, sort: sort},
                    dataType: 'html',
                    success: function (data) {
                        if (data != 'false') {
                            $(data).insertAfter($('.product').last());
                            if(moreProducts.data('last-page') == nextPage) {
                                moreProducts.addClass('d-none')
                            } else {
                                moreProducts.data('next-page', nextPage)
                            }
                            moreProducts.data('next-page', nextPage+1)
                        } else {
                            console.log('Ajax Error in script')
                        }
                    },
                    error: function (jqXHR, textStatus) {
                        console.log('Ajax', 'Error', textStatus)
                    }
                })
            }
        });
    })
}

$(function () {
    if (partnersSlick.length) {
        partnersSlick.slick({
            speed: 600,
            autoplay: true,
            autoplaySpeed: 2000,
            slidesToShow: 5,
            slidesToScroll: 1,
            accessibility: false,
            dots: false,
            infinite: true,
            prevArrow: "<div class='d-flex align-items-center'><i class=\"fas fa-chevron-left\"></i></div>",
            nextArrow: "<div class='d-flex align-items-center'><i class=\"fas fa-chevron-right\"></i></div>",
            responsive: [
                { breakpoint: 992, settings: { slidesToShow: 5 } },
                { breakpoint: 768, settings: { slidesToShow: 2 } },
                { breakpoint: 500, settings: { slidesToShow: 1 } }
            ]
        });
    }
})

let carouselUpperInner = $('#carouselUpper .carousel-inner')
let carouselUpper = $('#carouselUpper')
if(carouselUpper) {
    $( document ).ready(function() {
        setTimeout(function () {
            $('.carousel-item.active .carousel-caption').removeClass('hidden')
        }, 300)
    })
}
carouselUpper.on('slid.bs.carousel', function () {
    setTimeout(function () {
        $('.carousel-item.active .carousel-caption').removeClass('hidden')
    }, 200)
})
carouselUpper.on('slide.bs.carousel', function () {
    setTimeout(function () {
        $('.carousel-item.active .carousel-caption').addClass('hidden')
    }, 200)
})

if ($(window).width() < 768) {
    carouselUpperInner.on('touch tap click', function () {
        let link = $(this).find('.carousel-item.active a')
        if(link.length) {
            window.location.href = link.attr('href')
            return true
        }
        return false
    })
}

CookieConsent.run({
    manageScriptTags: true,
    cookie: { name: 'cc_cookie' },
    guiOptions: {
        consentModal: { layout: 'box', position: 'bottom right', equalWeightButtons: true, flipButtons: false },
        preferencesModal: { layout: 'box', equalWeightButtons: true, flipButtons: false }
    },
    categories: {
        necessary: { enabled: true, readOnly: true },
        analytics: { autoClear: { cookies: [ { name: /^_ga/ }, { name: '_gid' } ] } },
        ads: {}
    },
    language: {
        default: 'sk',
        translations: {
            sk: {
                consentModal: {
                    title: 'Na vašom súkromí nám záleží\n',
                    description: 'Táto webová stránka používa nevyhnutné súbory cookie na zabezpečenie správneho fungovania a s vaším súhlasom, aj na personalizáciu obsahu našich webových stránok.',
                    acceptAllBtn: 'Súhlasím',
                    showPreferencesBtn: 'Nastavenie cookies',
                },
                preferencesModal: {
                    title: 'Cookies nastavenia',
                    acceptAllBtn: 'Prijať všetko',
                    acceptNecessaryBtn: 'Odmietnúť všetko',
                    savePreferencesBtn: 'Uložiť nastavenia',
                    closeIconLabel: 'Zavrieť',
                    serviceCounterLabel: 'Služba|Služby',
                    sections: [
                        { title: '', description: `Súbory cookie používame na zabezpečenie základných funkcií stránky a na zlepšenie vášho používateľského zážitku. Svoj súhlas pre každú kategóriu môžete kedykoľvek zmeniť.` },
                        { title: 'Nevyhnutné cookies', description: 'Tieto cookies sú nevyhnutné pre správne fungovanie webovej stránky.', linkedCategory: 'necessary' },
                        { title: 'Analytické cookies', description: 'Tieto cookie využívame na analyzovanie prenosu a návštevnosti na našej webovej stránke.', linkedCategory: 'analytics' },
                        { title: 'Marketingové cookies', description: 'Vďaka marketingovým cookies bude pre Vás používanie nášho webu pohodlnejšie a prispôsobené Vašim preferenciám.', linkedCategory: 'ads', }
                    ]
                }
            },
            cs: {
                consentModal: {
                    title: 'Na vašem soukromí nám záleží\n',
                    description: 'Tato webová stránka používá nevyhnutelné soubory cookie na zabezpečení správného fungování a s vaším souhlasem i na personalizaci obsahu našich webových stránek.',
                    acceptAllBtn: 'Souhlasím',
                    acceptNecessaryBtn: 'Nesouhlasím',
                    showPreferencesBtn: 'Nastavení cookies',
                },
                preferencesModal: {
                    title: 'Cookies nastavení',
                    acceptAllBtn: 'Přijmout vše',
                    acceptNecessaryBtn: 'Zamítnout vše',
                    savePreferencesBtn: 'Uložit nastavení',
                    closeIconLabel: 'Zavřít',
                    serviceCounterLabel: 'Služba|Služby',
                    sections: [
                        { title: '', description: `Soubory cookie používáme k zajištění základních funkcí stránky a ke zlepšení vašeho uživatelského zážitku.` },
                        { title: 'Nevyhnutelné cookies', description: 'Tyto cookies jsou nevyhnutelné pro správné fungování webové stránky.', linkedCategory: 'necessary' },
                        { title: 'Analytické cookies', description: 'Tyto cookies využíváme na analyzování přenosu a návštěvnosti na naší webové stránce.', linkedCategory: 'analytics' },
                        { title: 'Marketingové cookies', description: 'Díky marketingovým cookies bude pro Vás používání našeho webu pohodlnější a přizpůsobené Vašim preferencím.', linkedCategory: 'ads', }
                    ]
                }
            }
        },
    }
});

const form = document.querySelector('#form');

function submitForm(e) {
    e.preventDefault();
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
        'event': 'form_sent'
    });
    form.submit()
}
if(form) {
    form.addEventListener('submit', submitForm);
}
